import { Component, Input, EventEmitter, Output } from '@angular/core';
import { PhxModalSize } from './phx-modal.types';
import { PHX_SIZE } from '../../constants';
import { KeyboardKeys } from '../../helpers/KeyboardKeys.enum';
import { PHX_MODAL_WIDTHS } from './phx-modal.constants';

@Component({ template: '' })
export class PhxModalBaseComponent {
  @Input() phxOpen: boolean = false;
  @Input() phxAutoClose: boolean = true;
  @Input() phxSize: PhxModalSize = PHX_SIZE.MD;

  @Output() phxOpenChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() phxBackdropClicked: EventEmitter<void> = new EventEmitter<void>();
  @Output() phxEscKeyPressed: EventEmitter<void> = new EventEmitter<void>();
  @Output() phxKeyDown: EventEmitter<KeyboardEvent> = new EventEmitter<KeyboardEvent>();

  public get modalWidth(): string | number {
    return PHX_MODAL_WIDTHS[this.phxSize];
  }

  public onBackdropClicked() {
    this.phxBackdropClicked.emit();
    if (this.phxAutoClose) this.closeModal();
  }

  public closeModal() {
    this.phxOpen = false;
    this.phxOpenChange.emit(false);
  }

  public onKeydown(event: KeyboardEvent) {
    if (this.phxOpen && event.key === KeyboardKeys.ESC) {
      this.phxEscKeyPressed.emit();

      if (this.phxAutoClose) {
        event.preventDefault();
        this.closeModal();
      }
    }
    this.phxKeyDown.emit(event);
  }
}
